import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AdminPrivateRoute = () => {
  const location = useLocation();

  // Retrieve admin and authentication status from location state
  const admin = location.state?.isAdmin;
  const token = location.state?.isAuthenticated;

  // Check if the user is an admin and authenticated
  if (admin && token) {
    // Render the nested routes if user is an admin and authenticated
    return <Outlet />;
  } else {
    // Redirect to login page if user is not an admin or not authenticated
    return <Navigate to="/" />;
  }
};

export default AdminPrivateRoute;
